import http from 'helpers/APIHelper';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';
import { httpStatusEnum } from 'appconstants';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';

export const PRT_FUNDING_ACTIONS = {
  GET_PROT_FUNDINGS: '@protocol/funding/getProtFundings',
  SET_PROT_FUNDING_INDEX: '@protocol/fundings/setProtFundingIndex',
  SET_SELECTED_FUNDING_ID: '@protocol/fundings/setSelectedFundingID'
};

export const setSelectedFundingId = props => dispatch => {
  const action = {
    type: PRT_FUNDING_ACTIONS.SET_SELECTED_FUNDING_ID,
    payload: props
  };
  dispatch(action);
};

export const setSelectedFundingIndex = props => dispatch => {
  const action = {
    type: PRT_FUNDING_ACTIONS.SET_PROT_FUNDING_INDEX,
    payload: props
  };
  dispatch(action);
};

export const getProtFunding = (token, loggerInfo, id) => dispatch => {
  dispatch({
    type: PRT_FUNDING_ACTIONS.GET_PROT_FUNDINGS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/fundings`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: PRT_FUNDING_ACTIONS.GET_PROT_FUNDINGS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: PRT_FUNDING_ACTIONS.GET_PROT_FUNDINGS + suffixRejected,
          payload: error
        });
      }
    );
};

export const saveFunding = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http.putWithToken(
  `protocol-data-service/${
    getSessionByKey('prt_url_ver')
  }/protocols/id/${id}/fundings`,
  token,
  loggerInfo,
  JSON.stringify(postBody)
).pipe(
  map(resp => {
    if (resp.status === httpStatusEnum.SUCCESS) {
      dispatch(
        getProtFunding(
          token,
          loggerInfo,
          getState().prtDetails.prtInfo.protocolNumber
        )
      );
    }
    return resp;
  })
);
